<div class="row page-title">
  <app-back-button [title]="localizationConstants.ADMIN_BACK_BUTTON_TITLE"></app-back-button>
  <span>{{ localizationConstants.CUSTOMER_SETTINGS_PAGE_TITLE | translate }}</span>
</div>
<div
  *ngIf="isLoading()"
  class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--light"
      size="2x"></app-loading-icon>
  </div>
</div>

<div [hidden]="isLoading()">
  <div class="row">
    <div class="c-details col-12 col-md-2 col-lg-1">
      <div class="c-details__action-button u-mt--large">
        <button
          (click)="openCreateModal()"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.BUTTON_ADD | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-sm-6 col-md-3 u-mb--medium">
      <form class="c-search-form--full">
        <div class="c-input-group">
          <input
            type="text"
            name="search"
            id="input-search"
            [(ngModel)]="dataSource().filter"
            class="c-input c-input--beta"
            placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
            required />

          <input
            *ngIf="!dataSource().filter"
            id="customer-settings-search"
            type="submit"
            class="c-button c-button--search c-button--search--sm"
            value="Search" />
          <input
            *ngIf="dataSource().filter"
            id="customer-settings-search-clear"
            (click)="dataSource().filter = ''"
            class="c-button c-button--search c-close-search c-button--search--sm"
            value="Clear" />
        </div>
      </form>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="u-scroll--horizontal">
        <table
          mat-table
          matSort
          [dataSource]="dataSource()"
          class="c-table col-md-4">
          <ng-container matColumnDef="companyId">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="10%">
              <span class="c-table__column-title">{{
                localizationConstants.CUSTOMER_SETTINGS_CUSTOMER_ID | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              {{ row.companyId }}
            </td>
          </ng-container>

          <ng-container matColumnDef="companyName">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="10%">
              <span class="c-table__column-title">{{
                localizationConstants.CUSTOMER_SETTINGS_CUSTOMER_NAME | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              {{ row.companyName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="unitOfMeasure">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="30%">
              <span class="c-table__column-title">{{
                localizationConstants.CUSTOMER_SETTINGS_UNIT_OF_MEASURE | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              <span>{{ row.unitOfMeasure }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="shippingAccountId">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="30%">
              <span class="c-table__column-title">{{
                localizationConstants.CUSTOMER_SETTINGS_SHIPPING_ACCOUNT | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              <span>{{ shippingAccountsIdNameMap()[row.shippingAccountId] }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="isShippingEnabled">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="30%">
              <span class="c-table__column-title">{{
                localizationConstants.CUSTOMER_SETTINGS_SHIPPING_ENABLED | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              <div class="flex">
                <input
                  type="checkbox"
                  name="isShippingEnabled"
                  [id]="'isShippingEnabled' + row.companyId"
                  [(ngModel)]="row.isShippingEnabled"
                  (change)="toggleShipping(row)"
                  class="c-checkbox-slider--sm" />
                <label
                  [for]="'isShippingEnabled' + row.companyId"
                  class="c-switch-slider--sm"></label>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="isTechCoverEnabled">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="30%">
              <span class="c-table__column-title">{{
                localizationConstants.CUSTOMER_SETTINGS_TECH_COVER_ENABLED | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              <div class="flex">
                <input
                  type="checkbox"
                  name="isTechCoverEnabled"
                  [id]="'isTechCoverEnabled' + row.companyId"
                  [(ngModel)]="row.isTechCoverEnabled"
                  (change)="toggleTechCover(row)"
                  class="c-checkbox-slider--sm" />
                <label
                  [for]="'isTechCoverEnabled' + row.companyId"
                  class="c-switch-slider--sm"></label>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="action1">
            <th
              mat-header-cell
              *matHeaderCellDef
              width="15%"></th>
            <td
              mat-cell
              *matCellDef="let row"
              class="action">
              <button
                type="button"
                class="button--sm button-block button-primary"
                (click)="editSettings(row)">
                <span>{{ localizationConstants.BUTTON_EDIT | translate }}</span>
              </button>
            </td>
          </ng-container>

          <tr
            matNoDataRow
            *matNoDataRow>
            <td colspan="12">
              <div class="center">
                {{ localizationConstants.TABLE_NO_RESULTS | translate }}
              </div>
            </td>
          </tr>
          <tr
            mat-header-row
            *matHeaderRowDef="columnsToDisplay"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: columnsToDisplay"
            class="c-table__row"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
